// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2i2Ja","addWidgetButton":"Header_addWidgetButton__2_eEO","dashboardTabs":"Header_dashboardTabs__2MPhd","active":"Header_active__25zX4"};